import './PeopleInfo.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { values, upperCase } from 'lodash'

import { safeMapLoop } from '../utils/misc'
import { getTranslateValue } from '../utils/locale'

import SearchLink from '../pages/searchResult/SearchLink'

import { PeopleItemFragment } from '../types/generated'

interface Props {
  peoples: PeopleItemFragment[]
}

enum PeopleTypes {
  CAST = 'cast',
  DIRECTOR = 'director',
  WRITER = 'writer',
}

export default function PeopleInfo({ peoples }: Props) {
  const { t } = useTranslation()
  if (peoples.length === 0) {
    return null
  }

  return (
    <div className="PeopleInfo">
      {values(PeopleTypes).map(peopleType => {
        const filteredPeoples = peoples.filter(people => people.role === peopleType)

        if (filteredPeoples.length === 0) {
          return null
        }

        return (
          <div key={peopleType} className="PeopleInfo__items">
            <SearchLink
              links={safeMapLoop(filteredPeoples, people => ({
                id: people.slug,
                title: getTranslateValue(people, 'name'),
                to: `/search?person=${people.slug}`,
              }))}
              title={upperCase(t(`program.${peopleType}`))}
            />
          </div>
        )
      })}
    </div>
  )
}
